// page init
jQuery(function() {
	initSelect2();
	initSlickCarousel();
	initStickyHeader();
	initMobileNav();
	initResizeEffect();

	jQuery(document).click(function(e) {
		var target = e.target;
		if (jQuery('body').hasClass('nav-active')) {
			if (!jQuery(target).hasClass('nav-opener') && !jQuery(target).parents('#header').length) {
				jQuery('body').removeClass('nav-active');
			}
		}
		if (jQuery('body').hasClass('cart-open')) {
			var insidePanel = jQuery(target).closest('.cart-header, .cart-holder, .cart-footer').length;
			if (!insidePanel && !jQuery(target).closest('.cart-opener').length) {
				jQuery('body').removeClass('cart-open');
			}
		}
       jQuery(document).mouseup(function(e) {
    		var searchContainer = jQuery("#header .search-form");
    		if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) {
    			jQuery('#search-resultsD').css('display', 'none');
    		}
    	});
      
	})
});

// select2 init
function initSelect2() {
	jQuery('.select2').select2({
		minimumResultsForSearch: -1,
		// placeholder: 'Select an option'
	});
}

// Tooltip
jQuery(function() {
	jQuery('[data-toggle="tooltip"]').tooltip();
})

// slick init
function initSlickCarousel() {
	jQuery('.hero-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 1,
		rows: 0,
		arrows: true,
		dots: true,
		fade: true,
		focusOnSelect: false,
		prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
		mobileFirst: true,
		infinite: true,
		autoplay: true
	});

 //    jQuery('.collection-carousel').slick({
	//     slidesToScroll: 1,
	//     slidesToShow: 1, // Keep this at 1 for basic Slick functionality
	//     rows: 0,
	//     arrows: false,
	//     dots: false,
	//     focusOnSelect: false,
	//     mobileFirst: true,
	//     infinite: true,
	//     autoplay: true, // Enable autoplay
	//     autoplaySpeed: 0, // Set to 0 for CSS animation control (explained below)
	//     speed: 5000, // Adjust this for the overall speed of one loop (milliseconds)
	//     cssEase: 'linear', // Constant speed for smooth marquee
	//     draggable: false, // Disable dragging for a true marquee feel
	//     swipe: false,     // Disable swiping
	//     touchThreshold: null,
	//     swipeToSlide: false,
	//     pauseOnFocus: false, // Prevent pausing on focus
	//     pauseOnHover: false, // Prevent pausing on hover
	//     responsive: [{
	//         breakpoint: 1200,
	//         settings: {
	//             slidesToShow: 3, // Adjust based on how many you want visible
	//         }
	//     },
	//     {
	//         breakpoint: 992,
	//         settings: {
	//             slidesToShow: 3,
	//         }
	//     },
	//     {
	//         breakpoint: 768,
	//         settings: {
	//             slidesToShow: 2,
	//         }
	//     },
	//     {
	//         breakpoint: 576,
	//         settings: {
	//             slidesToShow: 1,
	//         }
	//     },
	//     {
	//         breakpoint: 375,
	//         settings: {
	//             slidesToShow: 1,
	//         }
	//     }]
	// });

    jQuery('.collection-carousel').slick({
      slidesToScroll: 1,
      slidesToShow: 2,
      rows: 0,
      arrows: true,
      dots: false,
      focusOnSelect: false,
      prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
      infinite: true,
      autoplay: false,
      mobileFirst: true, // Corrected here
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 992,
              settings: {
                  slidesToShow: 3
              }
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2
              }
          },
          {
              breakpoint: 576,
              settings: {
                  slidesToShow: 2
              }
          },
          {
              breakpoint: 375,
              settings: {
                  slidesToShow: 2
              }
          }
      ]
  });

	$window = jQuery(window);
	prodSlider = jQuery('.product-slider');
	settings = {
		slidesToScroll: 1,
		slidesToShow: 3,
		rows: 0,
		arrows: true,
		dots: false,
		focusOnSelect: false,
		prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
		infinite: true,
		autoplay: true,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					centerMode: false,
					slidesToScroll: 1
				}
			},
			{	
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					centerMode: false,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: "unslick"
			}
		]
	};
	prodSlider.slick(settings);
	jQuery(window).on('resize', function() {
		if (jQuery(window).width() < 768) {
			if ($prodSlider.hasClass('slick-initialized')) {
				return prodSlider.slick(settings);
				prodSlider.slick('unslick');
			}
			return
		}
		if (!prodSlider.hasClass('slick-initialized')) {
			return prodSlider.slick(settings);
		}
	});

    jQuery('.product-slider-mb').slick({
		slidesToScroll: 1,
		slidesToShow: 3,
		rows: 0,
		arrows: true,
		dots: false,
		focusOnSelect: false,
		prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
		infinite: true,
		autoplay: true,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{	
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{	
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{	
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
            {  breakpoint: 375,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
  
	jQuery('.reviews-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 1,
		variableWidth: false,
		rows: 0,
		arrows: true,
		dots: true,
		centerMode: true,
		centerPadding: '54px',
		focusOnSelect: false,
		prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
		mobileFirst: true,
		infinite: true,
		autoplay: false,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerPadding: '268px',
                    variableWidth: false
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerPadding: '100px',
                    variableWidth: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	jQuery(function () {
    	const $window = jQuery(window);
    	const $slider = jQuery('.quotes-slider');
    
    	if (!$slider.length) return; // Exit if slider doesn't exist on this page
    
    	const settings = {
    		slidesToScroll: 1,
    		slidesToShow: 1,
    		rows: 0,
    		arrows: false,
    		dots: true,
    		centerMode: true,
    		centerPadding: '54px',
    		focusOnSelect: false,
    		mobileFirst: true,
    		infinite: true,
    		autoplay: true,
    		responsive: [
    			{
    				breakpoint: 992,
    				settings: "unslick"
    			},
    			{
    				breakpoint: 768,
    				settings: {
    					slidesToShow: 2,
    					slidesToScroll: 1
    				}
    			},
    			{
    				breakpoint: 375,
    				settings: {
    					slidesToShow: 1,
    					slidesToScroll: 1
    				}
    			}
    		]
    	};
    
    	// Initialize slick
    	$slider.slick(settings);
    
    	// Re-init slick on resize
    	$window.on('resize', function () {
    		if ($window.width() > 992) {
    			if ($slider.hasClass('slick-initialized')) {
    				$slider.slick('unslick');
    			}
    			return;
    		}
    		if (!$slider.hasClass('slick-initialized')) {
    			$slider.slick(settings);
    		}
    	});
    });

	jQuery('.slider-main').on('init', function(event, slick) {
      jQuery('.slider-main').css('visibility', 'visible').css('opacity', 1);
    }).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      mobileFirst: true,
      adaptiveHeight: true,
      prevArrow: '<button class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
      asNavFor: '.slider-nav',
      infinite: false,
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: false,
            arrows: false
          }
        },
        {
          breakpoint: 375,
          settings: {
            dots: true,
            arrows: true,
            infinite: false
          }
        }
      ]
    });

	jQuery('.slider-nav').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: '.slider-main',
		dots: false,
		arrows: false,
        variableWidth: true,
		focusOnSelect: true,
		mobileFirst: true,
		infinite: false,
		responsive: [{
			breakpoint: 992,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
                    infinite: false
				}
			}
		]
	});
}

// StickyHeader init
function initStickyHeader() {
	// jQuery(function() {
	// 	var stickyElement = jQuery(".sticky"),
	// 		stickyClass = "sticky-pin",
	// 		stickyPos = stickyElement.offset().top,
	// 		stickyHeight;
	// 	stickyElement.after('<div id="jumps-prevent"></div>');

	// 	function jumpsPrevent() {
	// 		stickyHeight = stickyElement.innerHeight();
	// 		stickyElement.css({ "margin-bottom": "-" + stickyHeight + "px" });
	// 		stickyElement.next().css({ "padding-top": +stickyHeight + "px" });
	// 	};
	// 	jumpsPrevent();
	// 	jQuery(window).resize(function() {
	// 		jumpsPrevent();
	// 	});

	// 	function stickerFn() {
	// 		var winTop = jQuery(this).scrollTop();
	// 		winTop >= stickyPos ?
	// 			stickyElement.addClass(stickyClass) :
	// 			stickyElement.removeClass(stickyClass)
	// 	};
	// 	stickerFn();
	// 	jQuery(window).scroll(function() {
	// 		stickerFn();
	// 	});
	// });
}


// MobileNav init
function initMobileNav() {
	jQuery('.nav-opener').click(function(e) {
		e.preventDefault();
		if (jQuery('body').hasClass('nav-active')) {
			jQuery('body').removeClass('nav-active');
		} else {
			jQuery('body').addClass('nav-active');
		}
	});
	jQuery('.nav-close').click(function(e) {
		e.preventDefault();
		if (jQuery('body').hasClass('nav-active')) {
			jQuery('body').removeClass('nav-active');
		}
	});

	jQuery('.cart-opener').click(function(e) {
		e.preventDefault();
		if (jQuery('body').hasClass('cart-open')) {
			jQuery('body').removeClass('cart-open');
		} else {
			jQuery('body').addClass('cart-open');
		}
	});
	jQuery('.cart-drop .btn-close').click(function(e) {
		e.preventDefault();
		jQuery('body').removeClass('cart-open');
	});
}

// Resize Effect function
function initResizeEffect() {
	jQuery(window).resize(function() {
		if (jQuery(window).width() > 767) {
			jQuery('body').removeClass('nav-active');
		}
	});
}

// Get the current year
var currentYear = new Date().getFullYear();
var elements = document.querySelectorAll(".currentYear");
elements.forEach(function(element) {
	element.textContent = currentYear;
});

jQuery('.modal').on('shown.bs.modal', function (e) {
	jQuery('.gallery-main, .gallery-nav').slick('setPosition');
	jQuery('.gallery-wrapper').addClass('open');

	jQuery('.search-results-slider').slick('setPosition');
	jQuery('.slider-wrapper').addClass('open');
})

// header search dropdown
jQuery('.btn-search').on('click', function() {
	jQuery('.search-area').slideDown(300);
});
jQuery('.btn-close').on('click', function(e) {
	e.preventDefault();
	jQuery('.search-area').slideUp(300);
});
// footer nav dropdown
jQuery('.f-nav h5').on('click', function() {
	jQuery(this).parent('.nav-box').toggleClass('nav-open');
	jQuery(this).next('.drop-box').slideToggle(300);
});

// QTY (exclude cart drawer — handled by theme.liquid's attachCartEventListeners)
const minus = $('.quantity__minus').not('.cart-drop .quantity__minus');
const plus = $('.quantity__plus').not('.cart-drop .quantity__plus');
minus.click(function(e) {
	e.preventDefault();
	var input = $(this).siblings('.quantity__input');
	var value = parseInt(input.val());
	if (value > 1) {
		value--;
	}
	input.val(value);
});
plus.click(function(e) {
	e.preventDefault();
	var input = $(this).siblings('.quantity__input');
	var value = parseInt(input.val());
	value++;
	input.val(value);
});

jQuery(window).bind("load resize scroll", function() {
	function adjustArrowPosition() {
		var imageHolderHeight = jQuery('.product-slider .image-holder, .product-slider-mb .image-holder, .collection-carousel .image-holder').innerHeight();
		var halfHeight = imageHolderHeight / 2;
		jQuery('.product-slider .slick-arrow, .product-slider-mb .slick-arrow, .collection-carousel .slick-arrow').css('top', halfHeight);
	}
	adjustArrowPosition();
});

// sticky side bar
jQuery(function () {
    const $sidebar = jQuery('.sidebar-links');
    const $header = jQuery('header');
    const $footer = jQuery('footer');
    const $sections = jQuery('.accordion-block');

    if (!$sidebar.length || !$header.length || !$footer.length || !$sections.length) return;

    const top = $sidebar.offset().top - parseFloat($sidebar.css('marginTop').replace(/auto/, 0));
    const headerHeight = $header.outerHeight();
    const footTop = $footer.offset().top - parseFloat($footer.css('marginTop').replace(/auto/, 0));
    const sidebarHeight = $sidebar.outerHeight();
    const maxY = footTop - sidebarHeight;

    // Function to handle sidebar link fixing
    function handleSidebarFixing() {
        const y = jQuery(this).scrollTop();
        if (y > top - headerHeight) {
            if (y < maxY - headerHeight) {
                $sidebar
                    .addClass('fixed')
                    .css({
                        position: 'fixed',
                        top: headerHeight + 'px',
                    });
            } else {
                $sidebar
                    .removeClass('fixed')
                    .css({
                        position: 'absolute',
                        top: (maxY - top + headerHeight) + 'px',
                    });
            }
        } else {
            $sidebar
                .removeClass('fixed')
                .removeAttr('style');
        }
    }

    // Function to handle active state of sidebar links
    function handleActiveState() {
        const windscroll = jQuery(this).scrollTop();
        const viewportHeight = jQuery(window).height();
        let currentActive = null;

        $sections.each(function (i) {
            const sectionTop = jQuery(this).offset().top;
            if (windscroll >= sectionTop - (viewportHeight / 4)) {
                currentActive = i;
            }
        });

        if (currentActive !== null) {
            $sidebar.find('li.active').removeClass('active');
            $sidebar.find('li').eq(currentActive).addClass('active');
        }

        if (windscroll === 0) {
            $sidebar.find('li.active').removeClass('active');
            $sidebar.find('li:first').addClass('active');
        }
    }

    // Smooth scroll
    $sidebar.find('a').on('click', function (e) {
        e.preventDefault();
        const target = jQuery(this).attr('href');
        if (jQuery(target).length) {
            const targetOffset = jQuery(target).offset().top - headerHeight;
            window.scrollTo({
                top: targetOffset,
                behavior: 'smooth'
            });
            handleActiveState();
        }
    });

    // Scroll listeners
    jQuery(window)
        .scroll(function () {
            handleSidebarFixing.call(this);
            handleActiveState.call(this);
        })
        .scroll();

    // Scroll on hash load
    jQuery(window).on('load', function () {
        if (window.location.hash) {
            const target = window.location.hash;
            if (jQuery(target).length) {
                const targetOffset = jQuery(target).offset().top - headerHeight;
                window.scrollTo({ top: targetOffset });
                handleActiveState();
            }
        }
    });
});

// Sticky collection list
document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header');
    let headerHeight = header ? header.offsetHeight : 0; // Initialize with a fallback

    const collectionsList = document.querySelector('.collections-list');
    const links = document.querySelectorAll('.collections-list a');
    const sections = document.querySelectorAll('.products-block');
    let isClickScrolling = false;

    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    }

    function checkStickyList() {
        if (!collectionsList || !header) return;

        const headerBottom = header.getBoundingClientRect().bottom;
        const collectionsTop = collectionsList.getBoundingClientRect().top;

        if (collectionsTop <= headerBottom && window.scrollY >= 1) {
            collectionsList.classList.add('stick');
            collectionsList.style.top = `${headerHeight}px`;
        } else {
            collectionsList.classList.remove('stick');
            collectionsList.style.top = '';

            if (links.length > 0 && !document.querySelector('.collections-list .active')) {
                addActiveClass(links[0]);
            }
        }
    }

    function removeActiveClasses(links) {
        links.forEach(link => link.parentElement.classList.remove('active'));
    }

    function addActiveClass(link) {
        link.parentElement.classList.add('active');
    }

    function onLinkClick(e) {
        e.preventDefault();
        const targetId = e.currentTarget.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        isClickScrolling = true;
        window.scrollTo({
            top: targetElement.offsetTop - headerHeight - 50,
            behavior: 'smooth'
        });
        removeActiveClasses(links);
        addActiveClass(e.currentTarget);
        // Call checkStickyList after the smooth scrolling finishes
        setTimeout(() => {
            isClickScrolling = false;
            checkStickyList(); // Ensure the sticky state is updated after scrolling
        }, 1000); // Match the delay used for isClickScrolling
    }

    links.forEach(link => link.addEventListener('click', onLinkClick));

    // Arrow navigation
    const navUl = collectionsList ? collectionsList.querySelector('ul') : null;
    const prevBtn = collectionsList ? collectionsList.querySelector('.collections-nav-prev') : null;
    const nextBtn = collectionsList ? collectionsList.querySelector('.collections-nav-next') : null;

    function updateArrows() {
        if (!navUl || !prevBtn || !nextBtn) return;
        prevBtn.classList.toggle('hidden', navUl.scrollLeft <= 0);
        nextBtn.classList.toggle('hidden', navUl.scrollLeft + navUl.clientWidth >= navUl.scrollWidth - 1);
    }

    if (prevBtn && nextBtn && navUl) {
        prevBtn.addEventListener('click', () => {
            navUl.scrollBy({ left: -200, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', () => {
            navUl.scrollBy({ left: 200, behavior: 'smooth' });
        });
        navUl.addEventListener('scroll', updateArrows);
        updateArrows();
    }

    window.addEventListener('scroll', () => {
        if (isClickScrolling) return;
        let current = '';
        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top;
            const sectionHeight = section.offsetHeight;
            if (sectionTop <= headerHeight && sectionTop + sectionHeight > headerHeight) {
                current = section.getAttribute('id');
            }
        });

        removeActiveClasses(links);
        links.forEach(link => {
            if (link.getAttribute('href').substring(1) === current) {
                addActiveClass(link);
            }
        });

        if (!current && links.length > 0) {
            addActiveClass(links[0]);	
        }
        checkStickyList(); // Keep the scroll check for normal scrolling
    });

    const debouncedCheckStickyList = debounce(checkStickyList, 150); // Increased debounce delay
    const handleResize = () => {
        headerHeight = header ? header.offsetHeight : 0; // Recalculate headerHeight on resize
        debouncedCheckStickyList();
    };

    window.addEventListener('resize', handleResize);

    // Initial call to set things up
    checkStickyList();
});


// Siber-links convertion into <select> options
document.addEventListener('DOMContentLoaded', function() {
	// Get the dropdown element
	const dropdown = document.getElementById('dropdown');

	// Exit early if dropdown doesn't exist on this page
	if (!dropdown) return;

	// Get the list items
	const listItems = document.querySelectorAll('.sidebar-links li');

	// Loop through the list items
	listItems.forEach((item) => {
		const anchor = item.querySelector('a');
		if (!anchor) return; // Skip if no anchor

		const href = anchor.getAttribute('href');
		const text = anchor.textContent;

		// Create and append option
		const option = document.createElement('option');
		option.value = href;
		option.textContent = text;
		dropdown.appendChild(option);
	});

	// Add event listener to the dropdown
	dropdown.addEventListener('change', function(event) {
		if (window.innerWidth < 992) {
			event.preventDefault();
			const targetId = this.value.substring(1);
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				const offset = 50;
				const elementPosition = targetElement.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - offset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		} else {
			window.location.href = this.value;
		}
	});
});

// Timeline js code
var nodes1 = Array.from(document.getElementsByClassName("timeline-badge"));
var nodes2 = Array.from(document.getElementsByClassName("timeline-panel"));
var nodes3 = Array.from(document.getElementsByClassName("timeline-panel-img"));
var circles = Array.from(document.getElementsByClassName("timeline-circle"));
const nodes = nodes1.concat(nodes2, nodes3);
const cache = {
	viewport: {},
	rects: []
};

window.addEventListener("load", init);

function init() {
	recache();
	document.addEventListener("scroll", throttle(scrollCheck, 10));
	window.addEventListener("resize", debounce(recache, 50));

	// Safely handle timeline height on pages where .timeline exists
	const timeline = document.querySelector('.timeline');
	if (timeline) {
		const firstLi = timeline.querySelector('li');
		if (firstLi) {
			const liHalfHeight = firstLi.offsetHeight / 2;
			timeline.style.setProperty('--timeline-after-height', `${liHalfHeight}px`);
		}
	}
}

function recache() {
	cache.viewport = {
		width: window.innerWidth,
		height: window.innerHeight
	};
	nodes.forEach((node, i) => {
		cache.rects[i] = rect(node);
	});
	scrollCheck();
}

function scrollCheck() {
	const offset = getScrollOffset();
	const midline = cache.viewport.height * 0.75;
	cache.rects.forEach((rect, i) => {
		nodes[i].classList.toggle("active", rect.y - offset.y < midline);
	});
	nodes1.forEach((badge, i) => {
		const rect = cache.rects[i];
		const isActive = rect.y - offset.y < midline;

		badge.classList.toggle("active", isActive);
		circles[i].classList.toggle("active", isActive);
	});
}

function getScrollOffset() {
	return {
		x: window.pageXOffset,
		y: window.pageYOffset
	};
}

function throttle(fn, limit, context) {
	let wait;
	return function () {
		context = context || this;
		if (!wait) {
			fn.apply(context, arguments);
			wait = true;
			return setTimeout(function () {
				wait = false;
			}, limit);
		}
	};
}

function debounce(fn, limit, immediate) {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			timeout = null;
			if (!immediate) fn.apply(context, args);
		}, limit);
		if (callNow) fn.apply(context, args);
	};
}

function rect(e) {
	const offset = getScrollOffset();
	const r = e.getBoundingClientRect();
	return {
		x: r.left + offset.x,
		y: r.top + offset.y
	};
}

// jQuery fade-in/out animation for .timeline-panel
$(window).on("load", function () {
	$(window).scroll(function () {
		var windowBottom = $(this).scrollTop() + $(this).innerHeight();
		$(".timeline-panel").each(function () {
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			if (objectBottom < windowBottom) {
				if ($(this).css("opacity") == 0) {
					$(this).fadeTo(500, 1);
				}
			} else {
				if ($(this).css("opacity") == 1) {
					$(this).fadeTo(500, 0);
				}
			}
		});
	}).scroll();
});

// Scroll listener for updating timeline line height (only if .timeline exists)
window.addEventListener("load", function () {
	const timeline = document.querySelector('.timeline');
	if (!timeline) return;

	window.addEventListener('scroll', function () {
		const timelineTop = timeline.getBoundingClientRect().top;
		const timelineHeight = timeline.offsetHeight;
		const windowHeight = window.innerHeight;

		const visibleHeight = windowHeight - timelineTop;

		if (timelineTop <= windowHeight && timelineTop + timelineHeight >= 0) {
			let newHeight = Math.min(Math.max(0, visibleHeight), timelineHeight);
			timeline.style.setProperty('--timeline-after-height', `${newHeight - 200}px`);
		} else {
			timeline.style.setProperty('--timeline-after-height', `0px`);
		}
	});
});

// Function to calculate the width of text
function getTextWidth(text, font) {
	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d');
	context.font = font || getComputedStyle(document.body).font;
	return context.measureText(text).width;
}

// Function to set the min-width of the element
function setMinWidthToText(element) {
	const text = element.innerText || element.textContent;
	const font = getComputedStyle(element).font;
	const textWidth = getTextWidth(text, font);
	element.style.minWidth = `${textWidth + 24}px`;
}

// Select all .date elements and set their min-width
const dateElements = document.querySelectorAll('.timeline .timeline-badge');
dateElements.forEach(setMinWidthToText);

// Adding focus on a div within the form elemnt
const labels = document.querySelectorAll('.qty-label');

labels.forEach(label => {
	const input = label.querySelector('input[type="radio"]');

	// Add focus to the checked one initially
	if (input.checked) {
		label.classList.add('focus');
		input.setAttribute('checked', 'checked');
	}

	label.addEventListener('click', () => {
		// Uncheck all and remove attributes/classes
		labels.forEach(l => {
			const i = l.querySelector('input[type="radio"]');
			l.classList.remove('focus');
			i.removeAttribute('checked');
			i.checked = false;
		});

		// Check the clicked one and update UI
		input.checked = true;
		input.setAttribute('checked', 'checked');
		label.classList.add('focus');
	});
});



// PDP Qty itmes control
document.addEventListener('DOMContentLoaded', function () {
	const formGroups = document.querySelectorAll('.form-group');
	const seeMoreButton = document.querySelector('.see-more');

	// Exit early if the button does not exist
	if (!seeMoreButton) return;

	if (formGroups.length > 6) {
		seeMoreButton.style.display = 'block';
		formGroups.forEach((formGroup, index) => {
			if (index >= 6) {
				formGroup.classList.add('hidden');
			}
		});
		seeMoreButton.addEventListener('click', function (event) {
			event.preventDefault();
			if (seeMoreButton.textContent.trim().toLowerCase() === 'see more quantities') {
				formGroups.forEach(formGroup => {
					formGroup.classList.remove('hidden');
				});
				seeMoreButton.textContent = 'See less quantities';
			} else {
				formGroups.forEach((formGroup, index) => {
					if (index >= 6) {
						formGroup.classList.add('hidden');
					}
				});
				seeMoreButton.textContent = 'See more quantities';
			}
		});
	} else {
		seeMoreButton.style.display = 'none';
	}
});

// pdp page divs collapse
jQuery('.box .box-title').click(function(e) {
	e.preventDefault();
	jQuery(this).parent('.box').toggleClass('open');
	jQuery(this).next('.box-slide').slideToggle(300);
});

